<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      
      <v-flex xs12 md6>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card>
              <v-system-bar color="accent" dark window>
                <v-icon center>mdi-account-card-details</v-icon>
                <v-toolbar-title class="ml-1">Личные данные</v-toolbar-title>
              </v-system-bar>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12 sm5 lg4 class="text-xs-center">
                    <img v-if="accountAvatar(500)"
                      :src="accountAvatar(500)"
                      alt="Фото профиля" 
                      width="100%" 
                      style="border-radius: 50%; border: 0px solid lightgrey; background: rgba(0, 0, 0, 0.03);"
                    >
                    <template v-else>
                      <v-icon style="font-size: 150px;">person</v-icon>
                      <p class="grey--text">Загрузите фото</p>
                    </template>
                  </v-flex>
                  <v-flex xs12 sm7 lg8>
                    <p class="display-1">{{ accountFullName }}</p>
                    <p class="subheading"><b>Дата рождения: </b> {{ account.birthdate || 'не указана' }}</p>
                    <p class="subheading"><b>Пол: </b> {{ gendertext }}</p>
                    <p class="subheading"><b>Часовой пояс: </b> {{ accountTimeZone + ' (' + $moment.tz(accountTimeZone).format('Z') + ') ' }}</p>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="info" small @click="openDialog('profile')">
                  <v-icon small>edit</v-icon> Редактировать
                </v-btn>
                <v-btn color="warning" small @click="openDialog('password')">
                  <v-icon small>lock</v-icon> Изменить пароль
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>

          <!-- Time zone -->
          <v-flex xs12>
            <v-card>
              <v-system-bar color="accent" dark window>
                <v-icon center>access_time</v-icon>
                <v-toolbar-title class="ml-1">Часовой пояс</v-toolbar-title>
              </v-system-bar>
              <v-card-text>
                <v-autocomplete
                  :items="timezones"
                  v-model="timezone"
                  label="Выберите часовой пояс"
                  single-line
                  clearable
                  open-on-clear
                  dont-fill-mask-blanks
                ></v-autocomplete>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="success" small @click.native="updateTimeZone" :disabled="timezone === accountTimeZone">Сохранить</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>

        </v-layout>
      </v-flex>

      <v-flex xs12 md6>
        <v-layout row wrap>

          <!-- Auth settings -->
          <v-flex xs12>
            <v-card>
              <v-system-bar color="accent" dark window>
                <v-icon center>receipt</v-icon>
                <v-toolbar-title class="ml-1">Средства аутентификации</v-toolbar-title>
              </v-system-bar>
              <v-card-text>
                <div>
                  <v-chip disabled>
                    <v-avatar class="accent">
                      <v-icon color="white">email</v-icon>
                    </v-avatar>
                    <span class="black--text">{{ (account.email) ? account.email : 'Добавьте Email' }}</span>
                    <v-tooltip top>
                      <v-icon right :color="account.confirmed_email ? 'green darken-1' : 'orange darken-4'" slot="activator">
                        {{ account.confirmed_email ? 'done' : 'error_outline' }}
                      </v-icon>
                      <span>{{ account.confirmed_email ? 'Подтверждён' : 'Не подтверждён' }}</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <v-btn icon style="margin-right: -10px" slot="activator" @click="openDialog('email')">
                        <v-icon>edit</v-icon>
                      </v-btn>
                      <span>Изменить</span>
                    </v-tooltip>
                  </v-chip>
                </div>
                <div>
                  <v-chip disabled>
                    <v-avatar class="accent">
                      <v-icon color="white">phone</v-icon>
                    </v-avatar>
                    <span class="black--text">{{ (account.phone > 0) ? account.phone : 'Добавьте телефон' }}</span>
                    <v-tooltip top>
                      <v-icon right :color="account.confirmed_phone ? 'green darken-1' : 'orange darken-4'" slot="activator">
                        {{ account.confirmed_phone ? 'done' : 'error_outline' }}
                      </v-icon>
                      <span>{{account.confirmed_phone ? 'Подтверждён' : 'Не подтверждён'}}</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <v-btn icon style="margin-right: -10px" slot="activator" @click="openDialog('phone')">
                        <v-icon>edit</v-icon>
                      </v-btn>
                      <span>Изменить</span>
                    </v-tooltip>
                  </v-chip>
                </div>
              </v-card-text>
            </v-card>
          </v-flex>

          <!-- Sessions -->
          <v-flex xs12>
            <v-card>
              <v-system-bar color="accent" dark window>
                <v-icon center>lock</v-icon>
                <v-toolbar-title class="ml-1">Активные сессии</v-toolbar-title>
              </v-system-bar>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-data-table
                      :headers="headers"
                      :items="sessions"
                      hide-actions
                    >
                      <template slot="items" slot-scope="props">
                        <td>{{ props.item.user_agent }}</td>
                        <td class="text-xs-center">{{ props.item.ip }}</td>
                        <td class="text-xs-center">{{ props.item.updated_at }}</td>
                        <td class="text-xs-center" :title="isCurrentSession(props.item) ? 'Нельзя завершить текущую сессию' : 'Завершить сессию'">
                          <v-btn
                            icon flat dark small
                            :color="isCurrentSession(props.item) ? 'grey' : 'deep-orange'"
                            @click="disconnectSession(props.item.id)"
                            :disabled="isCurrentSession(props.item)"
                          >
                            <v-icon>close</v-icon>
                          </v-btn>
                        </td>
                      </template>
                    </v-data-table>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="secondary" small @click="logoutAll" :disabled="!(sessions && sessions.length > 1)">
                  Завершить сессии
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>

        </v-layout>
      </v-flex>
      
      <v-dialog v-model="dialog" max-width="700px" scrollable>
        <component v-if="dialog" :is="currentComponent" v-bind="formProps" @close-dialog="dialog=false" @save="saveChanges"></component>
      </v-dialog>
    
    </v-layout>
  </v-container>
</template>

<script>
import AccountForm from './Forms/AccountForm'
import PasswordForm from './Forms/PasswordForm'
import ChangeAuthForm from './Forms/ChangeAuthForm'
import apiAccount from '../../api'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'Account',

  components: {
    AccountForm,
    PasswordForm,
    ChangeAuthForm
  },

  computed:{
    ...mapGetters('app/layout', ['getRouteData']),
    
    ...mapState('app/account', {
      companies: state => state.companies,
      account: state => state.profile,
    }),
    ...mapGetters('account', [
      'sessions'
    ]),
    ...mapGetters('app/account', [
      'accountFullName', 
      'accountAvatar', 
      'accountTimeZone',
      'getAuthTokens',
    ]),
    gendertext() {
      switch (this.account.gender) {
        case 1: return 'мужской'
        case 2: return 'женский'
        case 3: return 'другой'
        default: return 'не указан'
      }
    }
  },

  data() {
    return {
      dialog: false,
      currentComponent: null,
      formProps: {},
      timezones:[],
      timezone: null,
      headers: [
        { text: 'Устройство', align: 'left', value: 'user_agent' },
        { text: 'IP адрес', align: 'center', value: 'ip'},
        { text: 'Дата входа', align: 'center', value: 'date' },
        { text: 'Действия', value: '', width: '80px', sortable: false, }
      ],
    }
  },

  created(){
    if(this.account){
      this.timezone = this.account.timezone
    }
  },

  mounted() {
    if(this.$route.query.from === 'auth'){
      this.redirectDefaultCompany()
    }
    // Load account active sessions data.
    this.$store.dispatch('account/loadSessions')

    this.timezones = this.$moment.tz.names()
  },

  methods: {
    redirectDefaultCompany(){
      if(this.companies && this.companies.length>0){
        this.companies.map( company => {
          if(company.default){
            let query = {}
            company.posts.map(post => {
              if(post.default) query.pid=post.id
            })
            this.$router.push(this.getRouteData({ name: 'org.hierarchy', params: { cid: company.id }, query: query }))
          }
        })
      }
    },
    
    isCurrentSession(session) {
      return Boolean(session.id === this.getAuthTokens.id)
    },

    openDialog(type) {
      switch(type){
        case 'profile':
          this.formProps = {
            account: this.account
          }
          this.currentComponent = AccountForm
          break
        case 'password':
          this.formProps = {}
          this.currentComponent = PasswordForm
          break
        case 'email':
          this.formProps = {
            type: 'email',
            data: this.account.email
          }
          this.currentComponent = ChangeAuthForm
          break
        case 'phone':
          this.formProps = {
            type: 'phone',
            data: this.account.phone
          }
          this.currentComponent = ChangeAuthForm
          break
      }
      this.dialog = true
    },

    disconnectSession(id) {
      this.$dmsAgree({ message: 'Вы уверены, что хотите завершить сессию?', title: 'Завершение сессии', }).then(_ => {
        apiAccount.signOutOne(id).then(response => {
          const index = this.sessions.findIndex(el => el.id === id)
          if (index >= 0) {
            this.sessions.splice(index, 1)
          }
        })
      })
    },

    logoutAll() {
      this.$dmsAgree({ message: 'Вы уверены, что хотите завершить все сессии кроме текущей?', title: 'Завершение сессий', }).then(_ => {
        apiAccount.signOutAll().then(response => {
          let currentSession = this.sessions.find(elem => elem.id === this.getAuthTokens.id)
          this.$store.commit('account/setSessions', [currentSession])
        })
      })
    },

    saveChanges(eventData) {
      switch (eventData.type) {
        case 'email':
          // this.account.confirmed_email = true
          break
        case 'phone':
          // this.account.confirmed_phone = true
          break
        case 'profile':
          // this.account = Object.assign(this.account, eventData.data)
          break
      }
      this.dialog = false
    },
    
    saveAccount(event) {
      this.account = { ...event }
      this.dialog = false
    },

    updateTimeZone() {
      this.$store.dispatch('app/account/updateProfile', { timezone: this.timezone }).then(response => {
        this.$dmsSuccessNoty('Профиль успешно обновлён')
      }).catch(error => {
        this.$dmsErrorNoty('Ошибка обновления профиля')
      })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/apps/account/components/Account/Account.vue